import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import React, { useContext, useEffect, useState } from 'react';
import {
  useDeleteSipClientReasonAsync,
  useGetAllSipClientReasonByLicenseAsync,
  useGetAllSipClientReasonByLicenseCountAsync,
  useGetSipClientReasonByIdAsync,
} from '../../../services/SipClientReasonsService/hooks/useMutation';
import {
  ISipClientReasonProps,
  ISipClientReasonSimpleProps,
} from '../../../services/SipClientReasonsService/types';
import { IPaginationParams } from '../../../services/types';
import { Box } from '@mui/material';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';
import { AppContext } from '../../../context/AppContextProvider';
import ReasonEditionModal from './ReasonEditionModal';

const SipClientReasonsManagement = () => {
  const { showSnackbar } = useContext(AppContext);
  const [reasons, setReasons] = useState<ISipClientReasonSimpleProps[]>([]);
  const [count, setCount] = useState(0);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [reasonSelected, setReasonSelected] = useState<ISipClientReasonProps>();
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const [selectedItemToDelete, setSelectedItemToDelete] = useState<
    ISipClientReasonSimpleProps | undefined
  >();
  const [isVisibleReasonManagementModal, setIsVisibleReasonManagementModal] =
    useState(false);

  const { mutateAsync: mutateGetAllSipClientReasonByLicenseAsync } =
    useGetAllSipClientReasonByLicenseAsync();
  const { mutateAsync: mutateGetAllSipClientReasonByLicenseCountAsync } =
    useGetAllSipClientReasonByLicenseCountAsync();
  const { mutateAsync: mutateGetSipClientReasonByIdAsync } =
    useGetSipClientReasonByIdAsync();
  const { mutateAsync: mutateDeleteSipClientReasonAsync } =
    useDeleteSipClientReasonAsync();

  const columns: IColumnProps[] = [
    { label: 'Descrição', id: 'description' },
    {
      label: 'Ações',
      width: '0%',
      id: 'id',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDelete(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleEdit = async (id: number) => {
    await mutateGetSipClientReasonByIdAsync(id).then(setReasonSelected);
    setIsVisibleReasonManagementModal(true);
  };

  const handleDelete = async (id: number) => {
    setSelectedItemToDelete(reasons?.find((i) => i.id === id));
    setIsVisibleDeleteModal(true);
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteModal(false);
    setReasonSelected(undefined);
  };

  const handleConfirmDeletion = async () => {
    if (selectedItemToDelete?.id) {
      await mutateDeleteSipClientReasonAsync(selectedItemToDelete?.id, {
        onSuccess: (_) => {
          showSnackbar('Justificativa excluída com sucesso.', 'success');
        },
      });
      setSelectedItemToDelete(undefined);
      setIsVisibleDeleteModal(false);
      updateReasons(pagination);
    }
  };

  const updateReasons = (pagination: IPaginationParams) => {
    mutateGetAllSipClientReasonByLicenseAsync(pagination).then(setReasons);
    mutateGetAllSipClientReasonByLicenseCountAsync().then(setCount);
  };

  useEffect(() => {
    mutateGetAllSipClientReasonByLicenseAsync(pagination).then(setReasons);
  }, [pagination]);

  useEffect(() => {
    mutateGetAllSipClientReasonByLicenseCountAsync().then(setCount);
  }, []);

  return (
    <>
      <TableComponent
        title={'Justificativas para as chamadas'}
        totalCount={count}
        isPaginated
        rows={reasons}
        additionalTitleComponent={
          <Box gap={2} display={'flex'}>
            <ButtonComponent
              size={'small'}
              startIcon={<Add />}
              onClick={() => setIsVisibleReasonManagementModal(true)}
            >
              Nova justificativa
            </ButtonComponent>
          </Box>
        }
        onChangePageOrRowsPerPage={setPagination}
        columns={columns}
      />

      <ReasonEditionModal
        reasonSelected={reasonSelected}
        onClose={() => {
          updateReasons(pagination);
          setIsVisibleReasonManagementModal(false);
        }}
        isOpen={isVisibleReasonManagementModal}
      />

      <ConfirmDeleteModalComponent
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
        isVisibleDeleteDialog={isVisibleDeleteModal}
        message={`Tem certeza que deseja deletar a justificativa ${selectedItemToDelete?.description}?`}
        setIsVisibleDeleteDialog={setIsVisibleDeleteModal}
        title={'Deletar justificativa'}
      />
    </>
  );
};

export default SipClientReasonsManagement;
